import { DependencyList, useEffect } from 'react'
import { gsap } from 'gsap'

export const useGsapContext = (
  func: gsap.ContextFunc,
  deps: DependencyList = []
) => {
  useEffect(() => {
    const ctx = gsap.context(func)

    return () => {
      ctx.revert()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
